
import Vue from 'vue';
import AutocompleteDropdownV2 from '~/components/common/AutocompleteDropdownV2.vue';
import type { ISalesRole } from '~/types/community';
import type { CreateSalesRoleResponse } from '~/types/api';
import PlusIcon from '~/assets/svg/plus.vue.svg';

const MAX_ITEMS = 4;
const MIN_QUERY_LENGTH = 2;

type Data = {
  salesRoles: ISalesRole[];
  isTouched: boolean;
};

export default Vue.extend({
  name: 'CurrentTitleAutocomplete',
  components: {
    AutocompleteDropdownV2,
    PlusIcon,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    withAddNew: {
      type: Boolean,
      default: true,
    },
  },
  data(): Data {
    return {
      salesRoles: [],
      isTouched: false,
    };
  },
  computed: {
    autocompleteItems(): Array<ISalesRole> {
      // suggestions would not show if items empty
      return this.withSuggestion
        ? this.salesRoles
            .filter((salesRole: ISalesRole) => salesRole.name.toLowerCase().includes(this.value.toLowerCase()))
            .slice(0, MAX_ITEMS)
        : [];
    },
    withSuggestion(): boolean {
      return this.value.length >= MIN_QUERY_LENGTH && this.isTouched;
    },
    showAddNew(): boolean {
      return (
        Boolean(this.withAddNew) &&
        Boolean(this.value) &&
        !this.autocompleteItems.some((salesRole: ISalesRole) => this.value === salesRole.name) &&
        this.withSuggestion
      );
    },
  },
  mounted() {
    this.getSalesRoles();
  },
  methods: {
    async getSalesRoles(): Promise<void> {
      const { sales_roles: salesRoles } = await this.$api.$get('/api/war_room/sales_roles.json', {
        params: {
          custom: false,
        },
      });

      this.salesRoles = salesRoles;
    },
    async createSalesRole(name: string): Promise<ISalesRole | void> {
      try {
        const salesRole = await this.$api.$post<CreateSalesRoleResponse>('/api/war_room/sales_roles.json', { name });
        await this.getSalesRoles();

        return salesRole;
      } catch (e) {
        this.$notice.error(e);
        this.$sentryUtils.error(e);
      }
    },

    // Autocomplete returs own object
    handlePush(salesRole: ISalesRole & { value: string; text: string }): void {
      this.$emit('input', salesRole.name || salesRole.value);
    },
  },
});
